export default __webpack_public_path__ + "static/media/Transformer_08.16f2cc09.png";